module.exports = __webpack_public_path__ + "static/media/bg_21.df305f4a.png";